
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[url]",
      function () {
        return require("private-next-pages/author/[url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/[url]"])
      });
    }
  